import React from 'react';

interface CenterScreenComponentProps {}

export const CenterScreenComponent: React.FC<CenterScreenComponentProps> = ({ children }) => {
    return (
        <div
            style={{
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                display: 'flex',
                height: 400,
            }}
        >
            {children}
        </div>
    );
};
